import React from 'react';

function BetbookTicketPosts() {
    return <div>Ticket Arena</div>;
}

export default BetbookTicketPosts;
